<template>
  <v-container grid-list-md text-xs-center >
    <v-layout row wrap >
      <v-flex xs4></v-flex>
      <v-flex xs4>
        <v-card dark color="alert">
          <v-card-title primary-title>
            <div>
              <h3 class="headline mb-0">Select Index</h3>
              <div>currently available: schools, points of interest</div>
            </div>
          </v-card-title>
          <v-card-actions>
            <v-list>
            <v-btn
              large
              dark
              color="indigo"
              :to="'/poiindex'"
            >
              <v-icon left>mood</v-icon>Points of Interest
            </v-btn>
            <v-btn
              large
              color="red"
              :to="'/schoolIndex'"
            >
              <v-icon left>school</v-icon>Schools
            </v-btn>
            </v-list>
          </v-card-actions>
        </v-card>
      </v-flex>
      <v-flex xs4></v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  export default {
    data () {
      return {
        dialog: true
      }
    },
    computed: {
      setPixel () {
        return this.$store.getters.pixel
      }
    },
    methods: {
      twoTone (payload) {
        this.$store.dispatch('twoTone', payload)
        this.$router.push('/')
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/components/toolBox/selectorIndex.vue